// Fachada do domínio Agenda — métodos das instâncias (ver core.ts).
// Drop-in dos antigos src/services/{agendaService,meetingService,meetService}.
import { agendaService as agenda, meetingService as meeting } from './core';
import {
  generateMeetLink as _generateMeetLink,
  getCloserExternalBusy as _getCloserExternalBusy,
  MEETING_STATUS as _MEETING_STATUS,
  getMeetingStatusMeta as _getMeetingStatusMeta,
} from '@modules/agenda';

// ── agendaService (drop-in) ─────────────────────────────────────
export const getMeetingsByWeek          = agenda.getMeetingsByWeek;
export const getAvailableSlots          = agenda.getAvailableSlots;
export const scheduleMeeting            = agenda.scheduleMeeting;
export const updateMeetingLink          = agenda.updateMeetingLink;
export const editMeetingSchedule        = agenda.editMeetingSchedule;
export const swapMeetingCloser          = agenda.swapMeetingCloser;
export const clearCardReagend           = agenda.clearCardReagend;
export const getMeetingOrdinals         = agenda.getMeetingOrdinals;
export const discardReschedule          = agenda.discardReschedule;
export const handoffLeadToAgenda        = agenda.handoffLeadToAgenda;
export const getPendingAgendaMeetings   = agenda.getPendingAgendaMeetings;
export const getPendingReschedules      = agenda.getPendingReschedules;
export const confirmPresence            = agenda.confirmPresence;
export const cancelMeeting              = agenda.cancelMeeting;
export const registerNoShow             = agenda.registerNoShow;
export const registerResult             = agenda.registerResult;
export const updateMeetingStatusDirect  = agenda.updateMeetingStatusDirect;
export const getCloserSchedule          = agenda.getCloserSchedule;
export const getCloserBusyMeetings      = agenda.getCloserBusyMeetings;
export const getCloserGoogleBusy        = agenda.getCloserGoogleBusy;
export const resetMeetingToScheduled    = agenda.resetMeetingToScheduled;
export const getBlockedDates            = agenda.getBlockedDates;
export const upsertCloserSchedule       = agenda.upsertCloserSchedule;
export const upsertBlockedDate          = agenda.upsertBlockedDate;
export const deleteBlockedDate          = agenda.deleteBlockedDate;
export const getSchedulePerms           = agenda.getSchedulePerms;
export const addSchedulePerm            = agenda.addSchedulePerm;
export const removeSchedulePerm         = agenda.removeSchedulePerm;
export const getAgendaConfig            = agenda.getAgendaConfig;
export const setAgendaConfig            = agenda.setAgendaConfig;
export const listUsersByRole            = agenda.listUsersByRole;
export const listSdrs                   = agenda.listSdrs;
export const listWorkspaceMembers       = agenda.listWorkspaceMembers;
export const listClosers                = agenda.listClosers;
export const listSdrCardsForLead        = agenda.listSdrCardsForLead;
export const getWonCardsThisMonth       = agenda.getWonCardsThisMonth;
export const getSlotTimes               = agenda.getSlotTimes;
export const getPipelineMeetingDuration = agenda.getPipelineMeetingDuration;
export const setPipelineMeetingDuration = agenda.setPipelineMeetingDuration;
export const setSlotTimes               = agenda.setSlotTimes;
export const listCloserPipelines        = agenda.listCloserPipelines;
export const findCloserPipeline         = agenda.findCloserPipeline;

// ── meetingService (drop-in) ────────────────────────────────────
// NOTA: meetingService.cancelMeeting(id) colide com agendaService.cancelMeeting.
// O nome `cancelMeeting` fica com o de agenda (o efetivamente consumido); o de
// meeting é exposto como `cancelMeetingSimple` (não há consumidores hoje).
export const listMeetingsByLead   = meeting.listMeetingsByLead;
export const createMeeting        = meeting.createMeeting;
export const updateMeetingResult  = meeting.updateMeetingResult;
export const cancelMeetingSimple  = meeting.cancelMeeting;
export const MEETING_STATUS       = _MEETING_STATUS;
export const getMeetingStatusMeta = _getMeetingStatusMeta;

// ── meetService (drop-in) ───────────────────────────────────────
export const generateMeetLink = _generateMeetLink;
export const getCloserExternalBusy = _getCloserExternalBusy;

// ── Tipos públicos (re-export para consumidores) ────────────────
export type {
  GetMeetingsByWeekParams,
  GetAvailableSlotsParams,
  AvailableSlot,
  ScheduleMeetingParams,
  UpdateMeetingLinkParams,
  EditMeetingScheduleParams,
  SwapMeetingCloserParams,
  SwapMeetingCloserResult,
  DiscardRescheduleParams,
  HandoffLeadToAgendaParams,
  PendingAgendaMeetingsParams,
  PendingReschedulesParams,
  PendingRescheduleRow,
  ConfirmPresenceParams,
  CancelMeetingParams,
  RegisterNoShowParams,
  RegisterResultParams,
  CloserScheduleRow,
  CloserScheduleInsert,
  BlockedDateRow,
  BlockedDateInsert,
  SchedulePermRow,
  SchedulePermWithEditor,
  AddSchedulePermParams,
  AgendaConfig,
  SdrCardForLead,
  CloserPipeline,
  UpdateMeetingStatusDirectParams,
  FindCloserPipelineParams,
  CreateMeetingParams,
  MeetingDbStatus,
  GenerateMeetLinkParams,
} from '@modules/agenda';
export type { MeetingStatusMeta } from '@modules/agenda';
